// @core/api/endpoints/knowledge/create_knowledge_base.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateKnowledgeBaseRequest,
  KnowledgeBaseResponse,
} from '../../../types/knowledge';

const BASE_PATH = '/knowledge';

/**
 * Create knowledge base
 * Creates a knowledge base. The embedding model is fixed at creation; changing it later means creating a new base and reindexing. The caller becomes the owner.
 */
export async function CreateKnowledgeBase(
  data: CreateKnowledgeBaseRequest,
  options?: RequestOptions
): Promise<KnowledgeBaseResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/knowledge/bases`;
  const requestOptions = options;
  return client.post<KnowledgeBaseResponse>(requestPath, data, requestOptions);
}
